import { render, staticRenderFns } from "./LegalEditor.vue?vue&type=template&id=0804e11b&"
import script from "./LegalEditor.vue?vue&type=script&lang=js&"
export * from "./LegalEditor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports